module.exports = __webpack_public_path__ + "static/media/eye_visible.bf2488f5.svg";